import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

export default function Impressum() {
  const { t } = useTranslation();
  const isEN = i18n.language === 'en';

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Link to="/" className="text-sm text-primary-600 hover:text-primary-700 mb-6 inline-block">
        ← {t('footer.backToHome')}
      </Link>

      <h1 className="text-3xl font-bold text-gray-900 mb-8">{t('footer.impressum')}</h1>

      <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">

        {isEN ? (
          <>
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Information according to § 5 TMG (German Telemedia Act)</h2>
              <p>
                Timm Buse<br />
                Meiereistraße 6<br />
                24960 Munkbrarup<br />
                Germany
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Contact</h2>
              <p>
                Email: <a href="mailto:grenzland-liga@padelmap.app" className="text-primary-600 hover:text-primary-700">grenzland-liga@padelmap.app</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Responsible for content pursuant to § 18 (2) MStV</h2>
              <p>
                Timm Buse<br />
                Meiereistraße 6<br />
                24960 Munkbrarup
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Disclaimer</h2>

              <h3 className="text-base font-semibold text-gray-800 mt-4 mb-2">Liability for content</h3>
              <p>
                As a service provider, we are responsible for our own content on these pages in accordance with general law pursuant to § 7 (1) TMG.
                According to §§ 8 to 10 TMG, however, we are not obliged as a service provider to monitor transmitted or stored third-party information
                or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general law
                remain unaffected. Liability in this regard is only possible from the point in time at which we become aware of a specific infringement.
                Upon becoming aware of such infringements, we will remove this content immediately.
              </p>

              <h3 className="text-base font-semibold text-gray-800 mt-4 mb-2">Liability for links</h3>
              <p>
                Our offering contains links to external third-party websites over whose content we have no influence. We therefore cannot accept any
                liability for this external content. The respective provider or operator of the linked pages is always responsible for their content.
                The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognisable at the time of linking.
                Permanent monitoring of the content of linked pages is, however, unreasonable without concrete evidence of a violation.
                Upon becoming aware of legal violations, we will remove such links immediately.
              </p>

              <h3 className="text-base font-semibold text-gray-800 mt-4 mb-2">Copyright</h3>
              <p>
                The content and works created by the site operators on these pages are subject to German copyright law. Reproduction, editing, distribution
                and any kind of exploitation outside the limits of copyright law require the written consent of the respective author or creator.
                Downloads and copies of this site are only permitted for private, non-commercial use. Insofar as the content on this site was not created
                by the operator, the copyrights of third parties are respected. Should you nevertheless become aware of a copyright infringement,
                please notify us accordingly. Upon becoming aware of infringements, we will remove such content immediately.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Dispute resolution</h2>
              <p>
                The European Commission provides a platform for online dispute resolution (ODR):{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700">
                  https://ec.europa.eu/consumers/odr/
                </a>.
                Our email address can be found in the legal notice above. We are not willing or obliged to participate in dispute resolution
                proceedings before a consumer arbitration board.
              </p>
            </section>
          </>
        ) : (
          <>
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Angaben gemäß § 5 TMG</h2>
              <p>
                Timm Buse<br />
                Meiereistraße 6<br />
                24960 Munkbrarup<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Kontakt</h2>
              <p>
                E-Mail: <a href="mailto:grenzland-liga@padelmap.app" className="text-primary-600 hover:text-primary-700">grenzland-liga@padelmap.app</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
              <p>
                Timm Buse<br />
                Meiereistraße 6<br />
                24960 Munkbrarup
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Haftungsausschluss</h2>

              <h3 className="text-base font-semibold text-gray-800 mt-4 mb-2">Haftung für Inhalte</h3>
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
                Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen
                oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
                konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>

              <h3 className="text-base font-semibold text-gray-800 mt-4 mb-2">Haftung für Links</h3>
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte
                auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
                nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
                Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>

              <h3 className="text-base font-semibold text-gray-800 mt-4 mb-2">Urheberrecht</h3>
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber
                erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
                Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
                Inhalte umgehend entfernen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Streitschlichtung</h2>
              <p>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:text-primary-700">
                  https://ec.europa.eu/consumers/odr/
                </a>.
                Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </>
        )}

      </div>
    </div>
  );
}
